module.exports = __webpack_public_path__ + "static/media/goal_reached_img.8c4437b8.png";